import { DateUtils } from "../utils/DateUtils";
import _ from "lodash";
import { User } from "./User";

export class ModificationHistory {
    id?: number;
    description: string = "";
    field?: ModificationHistory.EField;
    field_type?: ModificationHistory.EFieldType;
    new_value?: string;
    old_value?: string;
    action_id: ModificationHistory.EAction =
        ModificationHistory.EAction.created;
    user?: User;
    created_at?: string;

    constructor(data: any) {
        var self = this;
        _.assign(this, _.omit(data, "user"));
        if (data.user) {
            self.user = new User(data.user);
        }
    }

    get creation_date_str(): string {
        if (this.created_at) {
            return DateUtils.sqlToDateStr(this.created_at, "DD/MM/YYYY HH:mm");
        } else {
            return "";
        }
    }

    get old_value_str(): string {
        return this.value_to_str(this.old_value);
    }

    get new_value_str(): string {
        return this.value_to_str(this.new_value);
    }

    value_to_str(value: any): string {
        if (this.field_type === ModificationHistory.EFieldType.bool) {
            return parseInt(value) ? "vrai" : "faux";
        } else if (this.field_type === ModificationHistory.EFieldType.date) {
            return DateUtils.sqlToDateStr(value);
        } else {
            return value ? value : "null";
        }
    }
}

export namespace ModificationHistory {
    export interface IAction {
        id: EAction;
        name: string;
    }

    export enum EAction {
        created = 0,
        updated = 1,
        deleted = 2,
        added = 3,
        removed = 4,
    }

    export const Action: { [index: number]: IAction } = {
        [EAction.created]: { id: EAction.created, name: "Créé" },
        [EAction.updated]: { id: EAction.updated, name: "Mise à jour" },
        [EAction.deleted]: { id: EAction.deleted, name: "Supprimé" },
        [EAction.added]: { id: EAction.added, name: "Ajout" },
        [EAction.removed]: { id: EAction.removed, name: "Suppression" },
    };

    export interface IField {
        id: EField;
        name: string;
    }

    export enum EField {
        // intervention
        date_prevue_intervention = "date_prevue_intervention",
        titre = "titre",
        duree_prevue = "duree_prevue",
        horaire_debut = "horaire_debut",
        horaire_fin = "horaire_fin",
        facturation = "facturation",
        etat = "etat",
        client = "client",
        employe = "employe",
        planning_id = "planning_id",
        start_date_effet = "start_date_effet",
        end_date_effet = "end_date_effet",
        rattrapable = "rattrapable",
    }

    export const Field: { [index: string]: IField } = {
        [EField.date_prevue_intervention]: {
            id: EField.date_prevue_intervention,
            name: "date prévue",
        },
        [EField.titre]: { id: EField.titre, name: "description" },
        [EField.duree_prevue]: {
            id: EField.duree_prevue,
            name: "durée prévue",
        },
        [EField.horaire_debut]: {
            id: EField.horaire_debut,
            name: "horaire début",
        },
        [EField.horaire_fin]: { id: EField.horaire_fin, name: "horaire fin" },
        [EField.facturation]: { id: EField.facturation, name: "facturation" },
        [EField.etat]: { id: EField.etat, name: "état" },
        [EField.client]: { id: EField.client, name: "client" },
        [EField.employe]: { id: EField.employe, name: "employé" },
        [EField.planning_id]: {
            id: EField.planning_id,
            name: "numéro de planning",
        },
        [EField.start_date_effet]: {
            id: EField.start_date_effet,
            name: "date d'effet (début)",
        },
        [EField.end_date_effet]: {
            id: EField.end_date_effet,
            name: "date d'effet (fin)",
        },
        [EField.rattrapable]: {
            id: EField.rattrapable,
            name: "rattrapage jours fériés",
        },
    };

    export enum EFieldType {
        date = "date",
        bool = "bool",
        int = "int",
        float = "float",
        string = "string",
    }
}
